
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightAlarmColourOff as ObiLightAlarmColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-alarm-colour-off.js';
 
 
 

 
 export const ObiLightAlarmColourOff = createComponent({
   react: React,
   tagName: 'obi-light-alarm-colour-off',
   elementClass: ObiLightAlarmColourOffElement,
   events: {
     
   }
  });
 
 